// verification-code-errors.data.ts
//
// The one-time code sent to the contact details on record (repeat prescriptions).

import { ErrorEntry } from './error-metadata.types';

export const verificationCodeErrors = {
  'unable-to-send-verification-code': {
    message: 'For security reasons, you can’t request another code right now.',
    title: 'Your verification code requests have been limited',
  },
  'organisation-not-configured-to-send-verification-code': {
    message:
      'We’re unable to continue your request because your GP practice isn’t set up to send confirmation codes.',
    title: 'Unable to proceed',
    components: [
      {
        name: 'mpf-tenant-info',
        props: {
          showCallSurgeryInstead: true,
        },
      },
    ],
  },
  'incorrect-verification-code-input': {
    message: 'You have entered in an incorrect code. Please try again.',
    title: 'Form validation error below verification code input.',
    redirectToError: false,
    details: 'Error details',
  },
  'verification-code-expired': {
    message: 'Your code has expired. Please request a new one to continue.',
    title: 'Form validation error below verification code input.',
    redirectToError: false,
  },
  'too-many-verification-code-failed-attempts': {
    message: 'You’ve entered an incorrect code too many times.',
    title: 'Your verification attempts have been limited',
  },
  'cannot-validate-multiple-verification-codes': {
    message:
      'This verification code has already been used. Press ‘Start again’ to request a new one.',
    title: 'This code has already been used',
    showBackButton: false,
  },
  'verification-code-not-found': {
    message: 'We couldn’t verify your code.',
    title: 'There is a problem with your verification',
  },
} satisfies Record<string, ErrorEntry>;
